import React from 'react';
import PropTypes from 'prop-types';

import withWebView from 'ggApp/shared/hocs/withWebView';

import { Wrap, Top, Bottom } from './styled';

import B2CRedirection from '../../modals/B2CRedirection';

const TopWithChecker = withWebView(Top);

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldShowMenu: false,
            b2cRedirectionModal: null,
        };
    }

    showMenu = () => {
        this.setState({
            shouldShowMenu: true,
        });
    };

    closeMenu = () => {
        this.setState({
            shouldShowMenu: false,
        });
    };

    toggleMenu = () => {
        this.setState((prevState) => ({
            shouldShowMenu: !prevState.shouldShowMenu,
        }));
    };

    createModalRefB2cRedirect = (modal) => {
        this.setState({ b2cRedirectionModal: modal });
    };

    render() {
        const { isLoggedIn, headerRef, isDesktopUser, isTransparent, className } = this.props;
        const { shouldShowMenu, b2cRedirectionModal } = this.state;
        return (
            <>
                <Wrap className={className} shouldShowMenu={shouldShowMenu} ref={headerRef}>
                    <TopWithChecker
                        isDesktopUser={isDesktopUser}
                        isTransparent={isTransparent}
                        isLoggedIn={isLoggedIn}
                        b2cRedirectionModal={b2cRedirectionModal}
                    />
                    <Bottom
                        shouldShowMenu={shouldShowMenu}
                        isTransparent={isTransparent}
                        showMenu={this.showMenu}
                        closeMenu={this.closeMenu}
                        toggleMenu={this.toggleMenu}
                        b2cRedirectionModal={b2cRedirectionModal}
                    />
                </Wrap>
                <B2CRedirection modalRef={this.createModalRefB2cRedirect} />
            </>
        );
    }
}

Header.propTypes = {
    isLoggedIn: PropTypes.bool,
    isDesktopUser: PropTypes.bool,
    headerRef: PropTypes.func,
};

Header.defaultProps = {
    isLoggedIn: false,
    isDesktopUser: true,
    headerRef: () => {},
};

export default Header;
